import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteFeatureFlag = (token, id) => {
    return fetch(`${apiUrl}feature_flags/${id}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default deleteFeatureFlag